import { getAuthorized } from "@/lib/fetch";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { Audit } from "./columns";

export enum AuditStatus {
  CREATED = "create",
  UPDATED = "update",
  DELETED = "delete",
  UNKNOWN = "unknown",
}

interface AuditResponse {
  data: Audit[];
  count: number;
}

export const useAudit = (elementId: number | string, client: string) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const adminIndex = pathSegments.indexOf("admin");
  let tableName =
    adminIndex >= 0 && pathSegments.length > adminIndex + 2
      ? pathSegments[adminIndex + 2]
      : "";
  const hasValidTableName = !!tableName;

  const { data, isLoading, error } = useQuery<AuditResponse>({
    queryKey: [client, "audits", "get", { audit_id: elementId }],
    queryFn: async () => {
      if (!elementId || !hasValidTableName) return null;

      const url = `${
        import.meta.env.VITE_BACKEND_URL
      }/${client}/${tableName}/audit?audit_id=${elementId}`;
      const res = await getAuthorized(url);
      return res.json();
    },
    enabled: !!elementId && hasValidTableName,
  });

  return {
    audit: data?.data,
    isLoading,
    error,
    status: data && data.count > 0 ? data.data[0].action : AuditStatus.UNKNOWN,
    isDeleted:
      data && data.count > 0 && data.data[0].action === AuditStatus.DELETED,
  };
};
